/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { colors, formStyles, mixins } from '@blend/consumer-components';

export namespace LongText {
  export interface Props extends React.HTMLAttributes<HTMLTextAreaElement> {}
}

const styles = StyleSheet.create({
  textarea: {
    height: 100,
    width: '100%',
    resize: 'none',
    border: 'none',
    ...formStyles.inputPadding(),
    ...mixins.inputBorderStyle,
    backgroundColor: colors.white,
  },
});

export const LongText: React.FC<LongText.Props> = ({ ...htmlProps }) => {
  return (
    <div data-it="it-LongText-content">
      <textarea className={css(styles.textarea)} {...htmlProps} />
    </div>
  );
};
